<template>
	<div class="progress-spinner" v-show="show">
		<div class="bounce1"></div>
		<div class="bounce2"></div>
		<div class="bounce3"></div>
	</div>		
</template>

<script>
	export default {
		props: {
			show: {
				type: Boolean,
				default: false
			}
		}
	}
</script>


<style lang="scss">
	.progress-spinner {
	    margin: 1.5rem auto;
	    width: 70px;
	    text-align: center;

	    display: flex;
	    flex-flow: row wrap;
	    justify-content: center;
	    align-items: center;

		> div {
		    width: 10px;
		    height: 10px;
		    background-color: rgba(238, 184, 95, .5);

		    margin-left: 2px;
		    margin-right: 2px;

		    border-radius: 100%;
		    display: inline-block;
		    -webkit-animation: spinner-bouncedelay 1.4s infinite ease-in-out both;
		    animation: spinner-bouncedelay 1.4s infinite ease-in-out both;
		}

		.bounce1 {
		    -webkit-animation-delay: -0.32s;
		    animation-delay: -0.32s;
		}

		.bounce2 {
		    -webkit-animation-delay: -0.16s;
		    animation-delay: -0.16s;
		}
	}

	@-webkit-keyframes spinner-bouncedelay {

	    0%,
	    80%,
	    100% {
	        -webkit-transform: scale(0)
	    }

	    40% {
	        -webkit-transform: scale(1.0)
	    }
	}

	@keyframes spinner-bouncedelay {

	    0%,
	    80%,
	    100% {
	        -webkit-transform: scale(0);
	        transform: scale(0);
	    }

	    40% {
	        -webkit-transform: scale(1.0);
	        transform: scale(1.0);
	    }
	}
</style>